export function can(
  permissions: any,
  resource: string,
  action: string
): boolean {
  const resources = permissions?.resources;
  if (!resources) return false;

  // superadmin wildcard
  if (resources["*"]?.includes("*")) return true;

  const allowed: string[] | undefined = resources[resource];
  return Array.isArray(allowed) && allowed.includes(action);
}
